<template>
  <v-dialog
    :value="value"
    persistent
    max-width="700px"
  >
    <v-card>
      <v-card-title>
        <h3>Automatischer Logout</h3>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-alert
          elevation="2"
          border="top"
          colored-border
          type="warning"
          class="mt-3"
        >
          Aufgrund von Inaktivität wurden Sie automatisch von Quanticy abgemeldet.<br>
          Bitte loggen Sie sich erneut ein.
        </v-alert>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-container class="d-flex justify-center">
          <v-btn
            color="primary"
            @click="goToLogin"
          >
            Zum Login
          </v-btn>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

// Dialog to redirect User to login page after auto-logout (session expired).
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    goToLogin() {
      this.$router.push("/login");
      this.$emit("input", false);
    }
  }	
}

</script>
